import React, { useEffect } from 'react';
import { Home } from './pages/Home';
const META_PIXEL_ID = '1082011774808964';
// Defer work until the page is loaded / idle, so third-party scripts never
// compete with the LCP image for bandwidth on slow connections.
function whenIdle(cb: () => void) {
  if (typeof window === 'undefined') return;
  const schedule = () => {
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(cb, {
        timeout: 3000
      });
    } else {
      setTimeout(cb, 1200);
    }
  };
  if (document.readyState === 'complete') schedule();else window.addEventListener('load', schedule, {
    once: true
  });
}
function useMetaPixel(pixelId: string) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Avoid double init
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'PageView');
      return;
    }
    // Defer the heavy fbevents.js download to idle so it doesn't compete with
    // the LCP image; the fbq() calls below queue until the script loads.
    whenIdle(() => {
      if ((window as any).fbq) {
        ;
        (window as any).fbq('track', 'PageView');
        return;
      }
      /* eslint-disable */
      ;
      (function (f: any, b: Document, v: string) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement('script') as HTMLScriptElement;
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName('script')[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', pixelId);
      (window as any).fbq('track', 'PageView');
    });
  }, [pixelId]);
}
export function App() {
  useMetaPixel(META_PIXEL_ID);
  return <>
      <Home data-id="element-0" data-mp="3uc9k7zkzlskv" />
      <noscript data-id="element-1" data-mp="3ucj91juaptoz">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3uf5g7id9y76o" />
      </noscript>
    </>;
}